import * as React from "react";

import { useDispatch, useSelector } from 'react-redux';
import { userAddressKey } from '../storage/storage-utils';
import { getReturnToPage } from '../registration/registration-utils';
import { setAddress, setReturnTo } from '../actions/registrationActions';
import { navigateTop } from '../routing/router-utils';
import { trackEvent } from '../analytics/tracking';
import { hasStoredValue, getStoredValue } from '../storage/storage-utils';

/**
 * This component:
 *
 * 1) Sets the post-registration returnTo page
 * 2) Redirects to the /address input page if no stored address is found
 *
 */
const SignUpWithAddress = () => {

  const dispatch = useDispatch();
  
  // The returnTo should only be set during the first render
  const returnToRef = React.useRef(); 

  // Redux may already have the address from splash page etc.
  const street_address = useSelector(state => state.street_address);

  React.useEffect(() => {
    // Set stored addresss in redux
    let locationObject = {};
    if (hasStoredValue(userAddressKey)) {
      locationObject = JSON.parse(getStoredValue(userAddressKey));
      if (locationObject.street_address) {
        dispatch(setAddress(locationObject));
      }
    }

    // Set the returnTo page
    if (!returnToRef.current) {
      returnToRef.current = getReturnToPage();
      dispatch(setReturnTo(returnToRef.current));
    }
    // Navigate to appropriate sign up page
    if (street_address || locationObject.street_address) {
      trackEvent('signup_with_address', 'reg_flow');  
      navigateTop('/signUp/signUp');
    } else {
      // Start with address lookup
      trackEvent('signup_without_address', 'reg_flow');
      navigateTop('/signUp/address');
    }
  }, [street_address, dispatch]);
  return null;
}

export default SignUpWithAddress;